export default "__VITE_ASSET__0ebe3a1c__"